import React, { Fragment } from "react";
import { Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import modules from "./modules";
import store from "application/reducer/store";

const App = () => {
  const history = createBrowserHistory();

  return (
    <Fragment>
      <Provider store={store}>
        <Router history={history}>
          {modules.map((module) => (
            <Route {...module.routeProps} key={module.name} />
          ))}
        </Router>
      </Provider>
    </Fragment>
  );
};

export default App;
